module.exports = __webpack_public_path__ + "ab0c20a01d8d7f46c01105157b2830cf.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/samsung-s6-white.png
// module id = 850
// module chunks = 0